import { useState } from "react";
import { AdminModules } from "../features";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import { useApolloQuery } from "../../../../hooks";
import { gql, useMutation } from "@apollo/client";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const GET_ROLE_WITH_PAGINATION = gql`
  query GetRolesWithPagination($page: Int!) {
    rolesWithPagination(page: $page) {
      collection {
        id
        name
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_ROLE = gql`
  mutation DeleteRole($id: ID!) {
    roleDelete(input: { id: $id }) {
      clientMutationId
      role {
        id
        name
      }
    }
  }
`;

function Role() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { translator } = useLanguageTranslator();
  const notify = useNotify();
  const navigate = useNavigate();
  const { user } = useAuthSession() as any;

  const { data, loading, refetch } = useApolloQuery({
    queryDocument: GET_ROLE_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteRole, { loading: deleteLoading, error }] = useMutation(
    DELETE_ROLE,
    {
      refetchQueries: ["GetRole"],
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  const modifiedGetRoles =
    data?.rolesWithPagination?.collection?.map((item: any) => {
      return {
        sr: item?.id,
        id: item?.id,
        name: item?.name,
      };
    });

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/role/update?id=${clickedId}`);
      return;
    }

    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deleteRole({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`Role Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  const tableColumns = [
    { id: "sr", label: "ID", minWidth: "100%", align: "left" },
    {
      id: "name",
      label: translator("dashboardTableHead.Name"),
      minWidth: "100%",
      align: "left",
    },
    {
      id: "id",
      label: translator("dashboardTableHead.Action"),
      minWidth: "100%",
      align: "right",
    },
  ];

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={`Role`}
        path="/admin/role/add-new"
        isAccounts={true}
        tableColumns={tableColumns}
        data={modifiedGetRoles}
        moduleKey="role-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={data?.rolesWithPagination?.metadata}
      />
    </>
  );
}

export { Role };
